import { View } from "@vnxjs/components"
import * as React from "react"
import { prefixClassname } from "../styles"

export default function SheetGap() {
  return <View className={prefixClassname("sheet__gap")} />
}
